import { sendErrorMetric } from "@expert/cloudwatch-metrics";

import { env } from "@/config";

/** `component` label scoping ui-orchestration's `RenderCrash` alert to our own boundaries (#2956). */
export const UI_ORCHESTRATION_COMPONENT = "ui-orchestration";

/** `action` label values for the `ExpertHubError` metric — one per Expert Hub data failure. */
export const EXPERT_HUB_ACTIONS = {
    /** Pay-metrics fetch rejected, or a 200 whose body failed the shape guard. */
    payMetricsFetchFailed: "pay_metrics_fetch_failed",
    /** Pay-metrics 200 with every totals bucket empty → blank cards despite success. */
    payMetricsEmpty: "pay_metrics_empty",
    /** Schedule fetch rejected, or a 200 that failed the shape guard. */
    scheduleFetchFailed: "schedule_fetch_failed",
    /** Schedule 200 but empty; on-site experts are only logged in when scheduled, so empty = data problem. */
    scheduleEmpty: "schedule_empty",
    /** Auto-available timer fired but the Offline->Available status write rejected or timed out. */
    autoAvailableSetFailed: "auto_available_set_failed",
} as const;

export type ExpertHubAction = (typeof EXPERT_HUB_ACTIONS)[keyof typeof EXPERT_HUB_ACTIONS];

/** Emit `ExpertHubError{action}`. Prod-only — non-prod shows mock data, so a failure isn't user-facing. */
export function emitExpertHubError(action: ExpertHubAction): void {
    if (!env.isProdMode) return;
    void sendErrorMetric("ExpertHubError", { action });
}
